import { render, staticRenderFns } from "./SimplePollsEditor.vue?vue&type=template&id=53af9824&scoped=true&"
import script from "./SimplePollsEditor.vue?vue&type=script&lang=js&"
export * from "./SimplePollsEditor.vue?vue&type=script&lang=js&"
import style0 from "./SimplePollsEditor.vue?vue&type=style&index=0&id=53af9824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53af9824",
  null
  
)

export default component.exports